export const mainColors = [
  { name: "Navy", hex: "#000080" },
  { name: "Red", hex: "#FF0000" },
  { name: "Blue", hex: "#0000FF" },
  { name: "Yellow", hex: "#FFFF00" },
  { name: "Green", hex: "#008000" },
  { name: "Orange", hex: "#FFA500" },
  { name: "Purple", hex: "#800080" },
  { name: "Tiffany Blue", hex: "#0ABAB5" },
  { name: "Coca-Cola Red", hex: "#E41A1C" },
  { name: "Barbie Pink", hex: "#DA1884" },
  { name: "Post-it Yellow", hex: "#FFFB00" },
  { name: "Pepsi Blue", hex: "#005CB4" },
  { name: "Spotify Green", hex: "#1DB954" },
  { name: "Google Blue", hex: "#4285F4" },
  { name: "Google Red", hex: "#EA4335" },
  { name: "Google Yellow", hex: "#FBBC05" },
  { name: "Google Green", hex: "#34A853" },
  { name: "Millennial Pink", hex: "#F3CFC6" },
  { name: "Burgundy", hex: "#800020" },
  { name: "Charcoal Gray", hex: "#36454F" },
  { name: "Ivory", hex: "#FFFFF0" },
  { name: "Champagne", hex: "#F7E7CE" },
  { name: "Navy Blue", hex: "#000080" },
  { name: "Emerald Green", hex: "#50C878" },
  { name: "Coral", hex: "#FF7F50" },
  { name: "Crimson", hex: "#DC143C" },
  { name: "Scarlet", hex: "#FF2400" },
  { name: "Turquoise", hex: "#40E0D0" },
  { name: "Lavender", hex: "#E6E6FA" },
  { name: "Magenta", hex: "#FF00FF" },
  { name: "Cyan", hex: "#00FFFF" },
  { name: "Beige", hex: "#F5F5DC" },
  { name: "Teal", hex: "#008080" },
  { name: "Indigo", hex: "#4B0082" },
  { name: "Maroon", hex: "#800000" },
  { name: "Sky Blue", hex: "#87CEEB" },
  { name: "Forest Green", hex: "#228B22" },
  { name: "Sunset Orange", hex: "#FD5E53" },
  { name: "Sand", hex: "#C2B280" },
  { name: "Rose", hex: "#FF007F" },
  { name: "Ocean Blue", hex: "#4F42B5" },
  { name: "Mint", hex: "#98FF98" },
  { name: "Black", hex: "#000000" },
  { name: "White", hex: "#FFFFFF" },
  { name: "Lime", hex: "#00FF00" },
  { name: "Aqua", hex: "#00FFFF" },
  { name: "Fuchsia", hex: "#FF00FF" },
  { name: "Chocolate", hex: "#D2691E" },
  { name: "Brown", hex: "#A52A2A" },
  { name: "Charcoal", hex: "#36454F" },
  { name: "Grey", hex: "#808080" },
  { name: "Butter", hex: "#FCE883" },
  { name: "Sandstone", hex: "#786D5F" },
  { name: "Pink", hex: "#FF69B4" },
];

export const colorsHex = [
  { name: "White", hex: "#FFFFFF" },
  { name: "Black", hex: "#000000" },
  { name: "Navy Blue", hex: "#000080" },
  { name: "Royal Blue", hex: "#4169E1" },
  { name: "Sky Blue", hex: "#87CEEB" },
  { name: "Red", hex: "#FF0000" },
  { name: "Maroon", hex: "#800000" },
  { name: "Burgundy", hex: "#800020" },
  { name: "Orange", hex: "#FFA500" },
  { name: "Yellow", hex: "#FFFF00" },
  { name: "Gold", hex: "#FFD700" },
  { name: "Green", hex: "#008000" },
  { name: "Forest Green", hex: "#228B22" },
  { name: "Olive Green", hex: "#808000" },
  { name: "Mint Green", hex: "#98FB98" },
  { name: "Purple", hex: "#800080" },
  { name: "Lavender", hex: "#E6E6FA" },
  { name: "Pink", hex: "#FFC0CB" },
  { name: "Hot Pink", hex: "#FF69B4" },
  { name: "Grey", hex: "#808080" },
  { name: "Charcoal Grey", hex: "#36454F" },
  { name: "Light Grey", hex: "#D3D3D3" },
  { name: "Brown", hex: "#A52A2A" },
  { name: "Khaki", hex: "#F0E68C" },
  { name: "Beige", hex: "#F5F5DC" },
  { name: "Dark Chocolate", hex: "#3F1D0D" },
  { name: "Dark Heather", hex: "#3A3B3C" },
  { name: "Irish Green", hex: "#009A44" },
  { name: "Light Blue", hex: "#ADD8E6" },
  { name: "Light Pink", hex: "#FFB6C1" },
  { name: "Natural", hex: "#FAE7B5" },
  { name: "Navy", hex: "#000080" },
  { name: "Sand", hex: "#C2B280" },
  { name: "Sport Grey", hex: "#A8A8A8" },
  { name: "Military Green", hex: "#4B5320" },
  { name: "Ash", hex: "#B2BEB5" },
  { name: "Carolina Blue", hex: "#7BAFD4" },
  { name: "Charcoal", hex: "#36454F" },
  { name: "Electric Green", hex: "#00FF00" },
  { name: "Garnet", hex: "#7C0A02" },
  { name: "Gravel", hex: "#808080" },
  { name: "Heather Military Green", hex: "#5B6656" },
  { name: "Heather Red", hex: "#C74C4C" },
  { name: "Heliconia", hex: "#FF4444" },
  { name: "Safety Orange", hex: "#FF6700" },
  { name: "Sapphire", hex: "#0F52BA" },
  { name: "Sky", hex: "#87CEEB" },
  { name: "Texas Orange", hex: "#A4532A" },
  { name: "Tropical Blue", hex: "#AEC6CF" },
  { name: "Tweed", hex: "#CFB53B" },
  { name: "Violet", hex: "#8F00FF" },
  { name: "Yellow Haze", hex: "#FFFACD" },
  { name: "Antique Jade Dome", hex: "#4682B4" },
  { name: "Azalea", hex: "#F7C1CC" },
  { name: "Cardinal Red", hex: "#C41E3A" },
  { name: "Graphite Heather", hex: "#4A4D4E" },
  { name: "Ice Grey", hex: "#D6D6D6" },
  { name: "Indigo Blue", hex: "#4B0082" },
  { name: "Kiwi", hex: "#8EE53F" },
  { name: "Lime", hex: "#00FF00" },
  { name: "Safety Green", hex: "#DFFF00" },
  { name: "Coral Silk", hex: "#FF7F50" },
  { name: "Heather Sapphire", hex: "#2A52BE" },
  { name: "Heather Navy", hex: "#2F4F4F" },
  { name: "Antique Sapphire", hex: "#27408B" },
  { name: "Blackberry", hex: "#8A2BE2" },
  { name: "Tennessee Orange", hex: "#FF8200" },
  { name: "Antique Cherry Red", hex: "#9E0E40" },
  { name: "Antique Irish Green", hex: "#006A4E" },
  { name: "Antique Orange", hex: "#E07A5F" },
  { name: "Berry", hex: "#990F4B" },
  { name: "Brown Savana", hex: "#8B5A2B" },
  { name: "Cornsilk", hex: "#FFF8DC" },
  { name: "Lilac", hex: "#C8A2C8" },
  { name: "Neon Blue", hex: "#1B03A3" },
  { name: "Neon Green", hex: "#39FF14" },
  { name: "Old Gold", hex: "#CFB53B" },
  { name: "Russet", hex: "#80461B" },
  { name: "Safety Pink", hex: "#FF91A4" },
  { name: "Cobalt", hex: "#0047AB" },
  { name: "Midnight", hex: "#191970" },
  { name: "Sunset", hex: "#FF4500" },
  { name: "Daisy", hex: "#FFEA00" },
  { name: "Turf Green", hex: "#3F704D" },
  // New colors given

  { name: "Antique Cherry Red", hex: "#971B2F" },
  { name: "Antique Denim", hex: "#313F4A" },
  { name: "Antique Heliconia", hex: "#AA0061" },
  { name: "Antique Irish Green", hex: "#00843D" },
  { name: "Antique Sapphire", hex: "#006A8E" },
  { name: "Apple Green", hex: "#8BC28C" },
  { name: "Ash", hex: "#C8C9C7" },
  { name: "Azalea", hex: "#DD74A1" },
  { name: "Baby Blue", hex: "#69B3E7" },
  { name: "Banana Cream", hex: "#FBD897" },
  { name: "Berry", hex: "#C3167C" },
  { name: "Black", hex: "#000000" },
  { name: "Bondi Blue", hex: "#289DBE" },
  { name: "Cancun", hex: "#58C9D4" },
  { name: "Cardinal Red", hex: "#8A1538" },
  { name: "Charcoal", hex: "#66676C" },
  { name: "Cherry Red", hex: "#AC2B37" },
  { name: "Chestnut", hex: "#8A4B32" },
  { name: "Coral Silk", hex: "#FB637E" },
  { name: "Daisy", hex: "#FED101" },
  { name: "Dark Chocolate", hex: "#382F2D" },
  { name: "Dark Heather", hex: "#425563" },
  { name: "Deep Teal", hex: "#00597A" },
  { name: "Electric Green", hex: "#43B02A" },
  { name: "Envy", hex: "#349C5E" },
  { name: "Espresso", hex: "#5F4C40" },
  { name: "Forest Green", hex: "#273B33" },
  { name: "Galaxy Purple", hex: "#404466" },
  { name: "Garnet", hex: "#7D2935" },
  { name: "Graphite Heather", hex: "#707372" },
  { name: "Heather Grey", hex: "#9EA2A2" },
  { name: "Heather Navy", hex: "#333F48" },
  { name: "Heavy Metal", hex: "#525A5B" },
  { name: "Heliconia", hex: "#DB3E79" },
  { name: "Hot Pink", hex: "#E55982" },
  { name: "Ice Grey", hex: "#D7D2CB" },
  { name: "Indigo", hex: "#34414E" },
  { name: "Irish Green", hex: "#00A74A" },
  { name: "Kelly Green", hex: "#00805E" },
  { name: "Khaki", hex: "#C3B091" },
  { name: "Kiwi", hex: "#89A84F" },
  { name: "Light Blue", hex: "#A4C8E1" },
  { name: "Light Green", hex: "#B2F44D" },
  { name: "Light Olive", hex: "#80856D" },
  { name: "Light Orange", hex: "#FFB59B" },
  { name: "Lilac", hex: "#D1ACCE" },
  { name: "Maroon", hex: "#5B2B42" },
  { name: "Midnight Navy", hex: "#2A3244" },
  { name: "Mint", hex: "#A0DAB3" },
  { name: "Natural", hex: "#E7CEB5" },
  { name: "Navy", hex: "#263147" },
  { name: "Oatmeal", hex: "#D2CFC4" },
  { name: "Olive", hex: "#4A412A" },
  { name: "Orange", hex: "#FFA00D" },
  { name: "Oxblood", hex: "#3D2D2E" },
  { name: "Peach", hex: "#F3BE8D" },
  { name: "Pebble", hex: "#857874" },
  { name: "Pebble Brown", hex: "#857874" },
  { name: "Pebble / Pebble Brown", hex: "#857874" },
  { name: "Pine", hex: "#425E5A" },
  { name: "Pink", hex: "#F8A3BC" },
  { name: "Plum", hex: "#5C3A4D" },
  { name: "Poppy", hex: "#E10600" },
  { name: "Purple", hex: "#464E7E" },
  { name: "Purple Berry", hex: "#936CA7" },
  { name: "Purple Rush", hex: "#603F83" },
  { name: "Raspberry", hex: "#E55982" },
  { name: "Red", hex: "#D50032" },
  { name: "Royal", hex: "#224D8F" },
  { name: "Safety Green", hex: "#C6D219" },
  { name: "Safety Orange", hex: "#E5801C" },
  { name: "Safety Pink", hex: "#E16F8F" },
  { name: "Sage", hex: "#7C6E4E" },
  { name: "Sand Dune", hex: "#C39D88" },
  { name: "Sea Green", hex: "#00BAB3" },
  { name: "Seafoam Blue", hex: "#A1D3D3" },
  { name: "Shiitake", hex: "#8A7E78" },
  { name: "Silk", hex: "#CACCCB" },
  { name: "Silver", hex: "#D1D5D0" },
  { name: "Soft Cream", hex: "#DECB99" },
  { name: "Sport Grey", hex: "#97999B" },
  { name: "Stone Gray", hex: "#8E918F" },
  { name: "Stonewash Green", hex: "#A3B5A6" },
  { name: "Storm", hex: "#404466" },
  { name: "Tahiti Blue", hex: "#33BECC" },
  { name: "Tan", hex: "#B49F89" },
  { name: "Teal", hex: "#099999" },
  { name: "Turquoise", hex: "#0088B0" },
  { name: "Vibrant Yellow", hex: "#FFDA29" },
  { name: "Vintage Black", hex: "#3D3535" },
  { name: "Vintage Navy", hex: "#2A3244" },
  { name: "Vintage Pink", hex: "#E55982" },
  { name: "Vintage Purple", hex: "#462639" },
  { name: "Vintage Red", hex: "#CD212A" },
  { name: "Vintage Royal", hex: "#1B5091" },
  { name: "Vintage Shocking Pink", hex: "#D84565" },
  { name: "White", hex: "#FFFFFF" },
  { name: "Yellow", hex: "#FED101" },

  // new set 1 gildan
  { name: "Amethyst", hex: "#6c4b94" },
  { name: "Antique Cherry Red", hex: "#971b2f" },
  { name: "Antique Heliconia", hex: "#aa0061" },
  { name: "Antique Irish Green", hex: "#00843d" },
  { name: "Antique Jade Dome", hex: "#062269" },
  { name: "Antique Orange", hex: "#b33d26" },
  { name: "Antique Royal", hex: "#003087" },
  { name: "Antique Sapphire", hex: "#006a8e" },
  { name: "Ash", hex: "#c8c9c7" },
  { name: "Ash Grey", hex: "#c8c9c7" },
  { name: "Azalea", hex: "#dd74a1" },
  { name: "Baby Blue", hex: "#69b3e7" },
  { name: "Berry", hex: "#7f2952" },
  { name: "Black", hex: "#25282a" },
  { name: "Blackberry", hex: "#221c35" },
  { name: "Blue Dusk", hex: "#253746" },
  { name: "Bright Salmon", hex: "#e5554f" },
  { name: "Brown Savana", hex: "#7a6855" },
  { name: "Cactus", hex: "#788a7a" },
  { name: "Cardinal Red", hex: "#8a1538" },
  { name: "Caribbean Blue", hex: "#00a9ce" },
  { name: "Caribbean Mist", hex: "#00a9ce" },
  { name: "Carolina Blue", hex: "#7ba4db" },
  { name: "Carolina Blue Mist", hex: "#7ba4db" },
  { name: "Cement", hex: "#aeaeae" },
  { name: "Chalky Mint", hex: "#5cb8b2" },
  { name: "Chambray", hex: "#bdd6e6" },
  { name: "Charcoal", hex: "#66676c" },
  { name: "Charity Pink", hex: "#f8a3bc" },
  { name: "Cherry Red", hex: "#ac2b37" },
  { name: "Chestnut", hex: "#83635c" },
  { name: "Cobalt", hex: "#171c8f" },
  { name: "Coral Silk", hex: "#fb637e" },
  { name: "Cornsilk", hex: "#f0ec74" },
  { name: "Daisy", hex: "#fed101" },
  { name: "Dark Chocolate", hex: "#382f2d" },
  { name: "Dark Heather", hex: "#425563" },
  { name: "Dune Mist", hex: "#7a7256" },
  { name: "Dusty Rose", hex: "#e1bbb4" },
  { name: "Electric Green", hex: "#43b02a" },
  { name: "Flo Blue", hex: "#5576d1" },
  { name: "Forest Green", hex: "#273b33" },
  { name: "Galapagos Blue", hex: "#005d6f" },
  { name: "Garnet", hex: "#7d2935" },
  { name: "Gold", hex: "#eead1a" },
  { name: "Graphite Heather", hex: "#707372" },
  { name: "Gravel", hex: "#888b8d" },
  { name: "Gunmetal", hex: "#939694" },
  { name: "Heather Berry", hex: "#994878" },
  { name: "Heather Blue", hex: "#3a5dae" },
  { name: "Heather Bronze", hex: "#c04c36" },
  { name: "Heather Cardinal", hex: "#9b2743" },
  { name: "Heather Caribbean Blue", hex: "#00afd7" },
  { name: "Heather Coral Silk", hex: "#ff808b" },
  { name: "Heather Dark Green", hex: "#3e5d58" },
  { name: "Heather Grey", hex: "#9ea2a2" },
  { name: "Heather Heliconia", hex: "#e24585" },
  { name: "Heather Indigo", hex: "#4d6995" },
  { name: "Heather Irish Green", hex: "#5caa7f" },
  { name: "Heather Military Green", hex: "#7e7f74" },
  { name: "Heather Navy", hex: "#333f48" },
  { name: "Heather Orange", hex: "#ff8d6d" },
  { name: "Heather Purple", hex: "#614b79" },
  { name: "Heather Radiant Orchid", hex: "#a15a95" },
  { name: "Heather Red", hex: "#bf0d3e" },
  { name: "Heather Royal", hex: "#307fe2" },
  { name: "Heather Sapphire", hex: "#0076a8" },
  { name: "Heather Seafoam", hex: "#40c1ac" },
  { name: "Heather Sport Dark Maroon", hex: "#651d32" },
  { name: "Heather Sport Dark Navy", hex: "#595478" },
  { name: "Heather Sport Royal", hex: "#1d4f91" },
  { name: "Heather Sport Scarlet Red", hex: "#b83a4b" },
  { name: "Heliconia", hex: "#db3e79" },
  { name: "Honey", hex: "#edaesa" },
  { name: "Ice Grey", hex: "#d7d2cb" },
  { name: "Indigo Blue", hex: "#486d87" },
  { name: "Iris", hex: "#3975b7" },
  { name: "Irish Green", hex: "#00a74a" },
  { name: "Island Reef", hex: "#8fd6bd" },
  { name: "Jade Dome", hex: "#00857d" },
  { name: "Kelly Green", hex: "#00805e" },
  { name: "Kiwi", hex: "#89a84f" },
  { name: "Lagoon Blue", hex: "#4ac3e0" },
  { name: "Legion Blue", hex: "#1f495b" },
  { name: "Light Blue", hex: "#a3b3cb" },
  { name: "Light Pink", hex: "#e4c6d4" },
  { name: "Lilac", hex: "#563d82" },
  { name: "Lime", hex: "#92bf55" },
  { name: "Marbled Charcoal", hex: "#66676c" },
  { name: "Marbled Galapagos Blue", hex: "#005d6f" },
  { name: "Marbled Heliconia", hex: "#db3e79" },
  { name: "Marbled Navy", hex: "#263147" },
  { name: "Marbled Royal", hex: "#224d8f" },
  { name: "Maroon", hex: "#5b2b42" },

  { name: "Maroon", hex: "#5b2b42" },
  { name: "Maroon Mist", hex: "#6d273c" },
  { name: "Meadow", hex: "#046a38" },
  { name: "Metro Blue", hex: "#464e7e" },
  { name: "Midnight", hex: "#056770" },
  { name: "Military Green", hex: "#5e7461" },
  { name: "Mint Green", hex: "#a0cfab" },
  { name: "Mint Green", hex: "#a0cfa8" },
  { name: "Moss", hex: "#3d441e" },
  { name: "Mustard", hex: "#c3964d" },
  { name: "Natural", hex: "#e7ceb5" },
  { name: "Navy", hex: "#263147" },
  { name: "Navy Mist", hex: "#2c4068" },
  { name: "Neon Blue", hex: "#0c51a3" },
  { name: "Neon Green", hex: "#93da49" },
  { name: "Old Gold", hex: "#c39367" },
  { name: "Olive", hex: "#4a412a" },
  { name: "Orange", hex: "#f4633a" },
  { name: "Orchid", hex: "#c5b4e3" },
  { name: "Paragon", hex: "#948794" },
  { name: "Pfd (Prepared For Dye)", hex: "#ffffff" },
  { name: "Pistachio", hex: "#a9c47f" },
  { name: "Pitch Black", hex: "#101820" },
  { name: "Pitch Black Mist", hex: "#2d2926" },
  { name: "Plumrose", hex: "#c9809e" },
  { name: "Prairie Dust", hex: "#7a7256" },
  { name: "Prairie Dust/Coyote Brown", hex: "#7a7256" },
  { name: "Purple", hex: "#464e7e" },
  { name: "Red", hex: "#d50032" },
  { name: "Royal", hex: "#224d8f" },
  { name: "Royal Mist", hex: "#456db0" },
  { name: "Rs Sport Grey", hex: "#97999b" },
  { name: "Rs Sport Grey / Black", hex: ["#97999b", "#25282a"] },
  { name: "Russet", hex: "#512f2e" },
  { name: "Safety Green", hex: "#c6d219" },
  { name: "Safety Orange", hex: "#e5801c" },
  { name: "Safety Pink", hex: "#e16f8f" },
  { name: "Sage", hex: "#819e89" },
  { name: "Sand", hex: "#cabfad" },
  { name: "Sapphire", hex: "#0077b5" },
  { name: "Seafoam", hex: "#487a7b" },
  { name: "Sky", hex: "#71c5e8" },
  { name: "Slate", hex: "#b3aaa4" },
  { name: "Smoke", hex: "#3d3935" },
  { name: "Sport Dark Green", hex: "#205c40" },
  { name: "Sport Dark Maroon", hex: "#572932" },
  { name: "Sport Dark Navy", hex: "#00263a" },
  { name: "Sport Grey", hex: "#97999b" },
  { name: "Sport Grey / Black", hex: ["#97999b", "#25282a"] },
  { name: "Sport Grey / Navy", hex: ["#97999b", "#263147"] },
  { name: "Sport Grey / Red", hex: ["#97999b", "#d50032"] },
  { name: "Sport Grey / Royal", hex: ["#97999b", "#224d8f"] },
  { name: "Sport Purple", hex: "#470a68" },
  { name: "Sport Royal", hex: "#002d72" },
  { name: "Sport Scarlet Red", hex: "#ba0c2f" },
  { name: "Steel Blue", hex: "#294f5a" },
  { name: "Stone Blue", hex: "#7e93a7" },
  { name: "Storm Grey", hex: "#898d8d" },
  { name: "Sunset", hex: "#dc6b2f" },
  { name: "Tan", hex: "#bd9a7a" },
  { name: "Tangerine", hex: "#ff8a3d" },
  { name: "Teal Ice", hex: "#b1e4e3" },
  { name: "Tennessee Orange", hex: "#b65a30" },
  { name: "Terracota", hex: "#e3775e" },
  { name: "Tropical Blue", hex: "#00859b" },
  { name: "True Red", hex: "#bb1237" },
  { name: "Turf Green", hex: "#007a3e" },
  { name: "Tweed", hex: "#4b4f54" },
  { name: "Vegas Gold", hex: "#f4d1a1" },
  { name: "Violet", hex: "#8094dd" },
  { name: "White", hex: "#ffffff" },
  { name: "White / Black", hex: ["#ffffff", "#25282a"] },
  { name: "White / Heliconia", hex: ["#ffffff", "#db3e79"] },
  { name: "White / Navy", hex: ["#ffffff", "#263147"] },
  { name: "White / Red", hex: ["#ffffff", "#d50032"] },
  { name: "White / Royal", hex: ["#ffffff", "#224d8f"] },
  { name: "Yellow Haze", hex: "#f5e1a4" },

  { name: "Maroon", hex: "#5b2b42" },
  { name: "Maroon Mist", hex: "#6d273c" },
  { name: "Meadow", hex: "#046a38" },
  { name: "Metro Blue", hex: "#464e7e" },
  { name: "Midnight", hex: "#056770" },
  { name: "Military Green", hex: "#5e7461" },
  { name: "Mint Green", hex: "#a0cfab" },
  { name: "Mint Green", hex: "#a0cfa8" },
  { name: "Moss", hex: "#3d441e" },
  { name: "Mustard", hex: "#c3964d" },
  { name: "Natural", hex: "#e7ceb5" },
  { name: "Navy", hex: "#263147" },
  { name: "Navy Mist", hex: "#2c4068" },
  { name: "Neon Blue", hex: "#0c51a3" },
  { name: "Neon Green", hex: "#93da49" },
  { name: "Old Gold", hex: "#c39367" },
  { name: "Olive", hex: "#4a412a" },
  { name: "Orange", hex: "#f4633a" },
  { name: "Orchid", hex: "#c5b4e3" },
  { name: "Paragon", hex: "#948794" },
  { name: "Pfd (Prepared For Dye)", hex: "#ffffff" },
  { name: "Pistachio", hex: "#a9c47f" },
  { name: "Pitch Black", hex: "#101820" },
  { name: "Pitch Black Mist", hex: "#2d2926" },
  { name: "Plumrose", hex: "#c9809e" },
  { name: "Prairie Dust", hex: "#7a7256" },
  { name: "Prairie Dust/Coyote Brown", hex: "#7a7256" },
  { name: "Purple", hex: "#464e7e" },
  { name: "Red", hex: "#d50032" },
  { name: "Royal", hex: "#224d8f" },
  { name: "Royal Mist", hex: "#456db0" },
  { name: "Rs Sport Grey", hex: "#97999b" },
  { name: "Rs Sport Grey", hex: "#25282a" },
  { name: "Russet", hex: "#512f2e" },
  { name: "Safety Green", hex: "#c6d219" },
  { name: "Safety Orange", hex: "#e5801c" },
  { name: "Safety Pink", hex: "#e16f8f" },
  { name: "Sage", hex: "#819e89" },
  { name: "Sand", hex: "#cabfad" },
  { name: "Sapphire", hex: "#0077b5" },
  { name: "Seafoam", hex: "#487a7b" },
  { name: "Sky", hex: "#71c5e8" },
  { name: "Slate", hex: "#b3aaa4" },
  { name: "Smoke", hex: "#3d3935" },
  { name: "Sport Dark Green", hex: "#205c40" },
  { name: "Sport Dark Maroon", hex: "#572932" },
  { name: "Sport Dark Navy", hex: "#00263a" },
  { name: "Sport Grey", hex: "#97999b" },
  { name: "Sport Grey", hex: "#25282a" },
  { name: "Sport Grey", hex: "#263147" },
  { name: "Sport Grey", hex: "#d50032" },
  { name: "Sport Grey", hex: "#224d8f" },
  { name: "Sport Purple", hex: "#470a68" },
  { name: "Sport Royal", hex: "#002d72" },
  { name: "Sport Scarlet Red", hex: "#ba0c2f" },
  { name: "Steel Blue", hex: "#294f5a" },
  { name: "Stone Blue", hex: "#7e93a7" },
  { name: "Storm Grey", hex: "#898d8d" },
  { name: "Sunset", hex: "#dc6b2f" },
  { name: "Tan", hex: "#bd9a7a" },
  { name: "Tangerine", hex: "#ff8a3d" },
  { name: "Teal Ice", hex: "#b1e4e3" },
  { name: "Tennessee Orange", hex: "#b65a30" },
  { name: "Terracota", hex: "#e3775e" },
  { name: "Tropical Blue", hex: "#00859b" },
  { name: "True Red", hex: "#bb1237" },
  { name: "Turf Green", hex: "#007a3e" },
  { name: "Tweed", hex: "#4b4f54" },
  { name: "Vegas Gold", hex: "#f4d1a1" },
  { name: "Violet", hex: "#8094dd" },
  { name: "White", hex: "#ffffff" },
  { name: "White", hex: "#25282a" },
  { name: "White", hex: "#db3e79" },
  { name: "White", hex: "#263147" },
  { name: "White", hex: "#d50032" },
  { name: "White", hex: "#224d8f" },
  { name: "Yellow Haze", hex: "#f5e1a4" },

  { name: "Antique Denim", hex: "#313f4a" },
  { name: "Apple Green", hex: "#8bc28c" },
  { name: "Banana Cream", hex: "#fbd897" },
  { name: "Black", hex: "#27272a" },
  { name: "Bondi Blue", hex: "#289dbe" },
  { name: "Cancun", hex: "#58c9d4" },
  { name: "Charcoal", hex: "#41424a" },
  { name: "Dark Chocolate", hex: "#3c302f" },
  { name: "Envy", hex: "#349c5e" },
  { name: "Espresso", hex: "#5f4c40" },
  { name: "Galaxy Purple", hex: "#404466" },
  { name: "Heather Forest Green", hex: "#2f5050" },
  { name: "Heather Gray", hex: "#a19fa5" },
  { name: "Heavy Metal", hex: "#525a5b" },
  { name: "Hot Pink", hex: "#e55982" },
  { name: "Ice Blue", hex: "#cbdcdf" },
  { name: "Indigo", hex: "#34414e" },
  { name: "Kelly Green", hex: "#008c45" },
  { name: "Light Olive", hex: "#80856d" },
  { name: "Light Orange", hex: "#ffb59b" },
  { name: "Light Pink", hex: "#f5bec7" },
  { name: "Lilac", hex: "#d1acce" },
  { name: "Midnight Navy", hex: "#2a3244" },
  { name: "Military Green", hex: "#656344" },
  { name: "Mint", hex: "#afddcc" },
  { name: "Neon Yellow", hex: "#f0e366" },
  { name: "Oatmeal", hex: "#d2cfc4" },
  { name: "Orange", hex: "#ffa00d" },
  { name: "Oxblood", hex: "#3d2d2e" },
  { name: "Plum", hex: "#5c3a4d" },
  { name: "Purple Berry", hex: "#936ca7" },
  { name: "Purple Rush", hex: "#603f83" },
  { name: "Raspberry", hex: "#e55982" },
  { name: "Red", hex: "#cd212a" },
  { name: "Royal", hex: "#1b5091" },
  { name: "Sage", hex: "#7c6e4e" },
  { name: "Shiitake", hex: "#8a7e78" },
  { name: "Silk", hex: "#cacccb" },
  { name: "Silver", hex: "#d1d5d0" },
  { name: "Stone Gray", hex: "#8e918f" },
  { name: "Stonewash Green", hex: "#a3b5a6" },
  { name: "Storm", hex: "#404466" },
  { name: "Tahiti Blue", hex: "#33becc" },
  { name: "Tan", hex: "#b49f89" },
  { name: "Teal", hex: "#099999" },
  { name: "Turquoise", hex: "#0088b0" },
  { name: "Vibrant Yellow", hex: "#ffda29" },
  { name: "Vintage Black", hex: "#3d3535" },
  { name: "Vintage Navy", hex: "#2a3244" },
  { name: "Vintage Pink", hex: "#e55982" },
  { name: "Vintage Purple", hex: "#462639" },
  { name: "Vintage Red", hex: "#cd212a" },
  { name: "Vintage Royal", hex: "#1b5091" },
  { name: "Vintage Shocking Pink", hex: "#d84565" },
  { name: "White", hex: "#f4f9ff" },

  { name: "Aqua", hex: "#4298b5" },
  { name: "Aqua Triblend", hex: "#009ec4" },
  { name: "Army", hex: "#55574c" },
  { name: "Ash", hex: "#edf1ff" },
  { name: "Asphalt", hex: "#6c6864" },
  { name: "Asphalt Slub", hex: "#54585a" },
  { name: "Athletic Grey Triblend", hex: "#898d8d" },
  { name: "Athletic Heather", hex: "#acb1a6" },
  { name: "Atlantic", hex: "#113b40" },
  { name: "Autumn", hex: "#9c5331" },
  { name: "Baby Blue", hex: "#83b0c1" },
  { name: "Berry", hex: "#c3167c" },
  { name: "Berry Triblend", hex: "#ac145a" },
  { name: "Black Heather", hex: "#454038" },
  { name: "Black Marble", hex: "#2a2829" },
  { name: "Black Mineral Wash", hex: "#25282a" },
  { name: "Black Slub", hex: "#111c24" },
  { name: "Black Speckled", hex: "#2d2926" },
  { name: "Blue Marble", hex: "#70a7d0" },
  { name: "Blue Triblend", hex: "#6e8ec0" },
  { name: "Brick", hex: "#973a36" },
  { name: "Brown", hex: "#5e514d" },
  { name: "Bubble Gum", hex: "#f8a3bc" },
  { name: "Burnt Orange", hex: "#cb6015" },
  { name: "Canvas Red", hex: "#9d2235" },
  { name: "Cardinal", hex: "#9b2743" },
  { name: "Carolina Blue", hex: "#8baad4" },
  { name: "Cement", hex: "#d2cfc4" },
  { name: "Charcoal Black Triblend", hex: "#3d3935" },
  { name: "Charcoal Marble", hex: "#434343" },
  { name: "Charity Pink", hex: "#df6797" },
  { name: "Chestnut", hex: "#8a4b32" },
  { name: "Citron", hex: "#dde3d5" },
  { name: "Clay", hex: "#a26859" },
  { name: "Clay Triblend", hex: "#7d2b27" },
  { name: "Columbia Blue", hex: "#5571a4" },
  { name: "Cool Blue", hex: "#01426a" },
  { name: "Cool Grey", hex: "#c4bcb7" },
  { name: "Coral", hex: "#f87c56" },
  { name: "Currant", hex: "#ab3475" },
  { name: "Dark Grey", hex: "#38484e" },
  { name: "Dark Grey Heather", hex: "#525657" },
  { name: "Dark Lavender", hex: "#9b91be" },
  { name: "Dark Olive", hex: "#36362d" },
  { name: "Deep Heather", hex: "#75726f" },
  { name: "Deep Heather Speckled", hex: "#6a6865" },
  { name: "Deep Teal", hex: "#00597a" },
  { name: "Denim", hex: "#4b808c" },
  { name: "Dust", hex: "#cdc6bd" },
  { name: "Dusty Blue", hex: "#9bb2a2" },
  { name: "Electric Blue", hex: "#006eb3" },
  { name: "Emerald", hex: "#13322b" },
  { name: "Emerald Triblend", hex: "#173f35" },
  { name: "Espresso", hex: "#392d2b" },
  { name: "Evergreen", hex: "#115740" },
  { name: "Forest", hex: "#183028" },
  { name: "French Vanilla", hex: "#f1e19b" },
  { name: "Fuchsia", hex: "#db0a5b" },
  { name: "Gold", hex: "#ffa300" },
  { name: "Granite", hex: "#8d9081" },
  { name: "Grass Green", hex: "#427c66" },
  { name: "Green", hex: "#60b066" },
  { name: "Grey", hex: "#323331" },
  { name: "Grey Acid Fleece", hex: "#25282a" },
  { name: "Grey Acid Wash", hex: "#25282a" },
  { name: "Grey Triblend", hex: "#7b7d72" },

  { name: "Heather Aqua", hex: "#48a9c5" },
  { name: "Heather Autumn", hex: "#a66646" },
  { name: "Heather Baby Blue", hex: "#83b0c1" },
  { name: "Heather Blue", hex: "#8e9fbc" },
  { name: "Heather Blue Lagoon", hex: "#86a1a9" },
  { name: "Heather Brown", hex: "#5e4b3c" },
  { name: "Heather Bubble Gum", hex: "#f8a3bc" },
  { name: "Heather Canvas Red", hex: "#bf0d3e" },
  { name: "Heather Cardinal", hex: "#651d32" },
  { name: "Heather Carolina Blue", hex: "#8baad4" },
  { name: "Heather Charity Pink", hex: "#e16f8f" },
  { name: "Heather Clay", hex: "#a26859" },
  { name: "Heather Columbia Blue", hex: "#658bcc" },
  { name: "Heather Deep Teal", hex: "#34657f" },
  { name: "Heather Dust", hex: "#cdc6bd" },
  { name: "Heather Dusty Blue", hex: "#9bb2a2" },
  { name: "Heather Emerald", hex: "#13322b" },
  { name: "Heather Forest", hex: "#48655b" },
  { name: "Heather French Vanilla", hex: "#f1e19b" },
  { name: "Heather Gold", hex: "#ffa300" },
  { name: "Heather Grass Green", hex: "#427c66" },
  { name: "Heather Green", hex: "#79863c" },
  { name: "Heather Ice Blue", hex: "#c4e1de" },
  { name: "Heather Kelly", hex: "#00965e" },
  { name: "Heather Lapis", hex: "#5c619d" },
  { name: "Heather Marmalade", hex: "#ffa010" },
  { name: "Heather Maroon", hex: "#5b2b42" },
  { name: "Heather Mauve", hex: "#a36d6a" },
  { name: "Heather Midnight Navy", hex: "#313546" },
  { name: "Heather Military Green", hex: "#6c6e60" },
  { name: "Heather Mint", hex: "#a8d5ba" },
  { name: "Heather Mustard", hex: "#c6973f" },
  { name: "Heather Natural", hex: "#e9dbb3" },
  { name: "Heather Navy", hex: "#3b4559" },
  { name: "Heather Oatmeal", hex: "#d1ccbd" },
  { name: "Heather Olive", hex: "#7f7457" },
  { name: "Heather Orange", hex: "#ff6a39" },
  { name: "Heather Orchid", hex: "#b0879b" },
  { name: "Heather Peach", hex: "#f3be8d" },
  { name: "Heather Pink", hex: "#f7ced7" },
  { name: "Heather Pink Gravel", hex: "#c5aa9c" },
  { name: "Heather Prism Blue", hex: "#a5b3cc" },
  { name: "Heather Prism Dusty Blue", hex: "#9bb2a2" },
  { name: "Heather Prism Ice Blue", hex: "#bad1be" },
  { name: "Heather Prism Lilac", hex: "#c7a1b2" },
  { name: "Heather Prism Mint", hex: "#a0dab3" },
  { name: "Heather Prism Natural", hex: "#d2cfc4" },
  { name: "Heather Prism Peach", hex: "#eabeb0" },
  { name: "Heather Prism Sunset", hex: "#ec9865" },
  { name: "Heather Purple", hex: "#836995" },
  { name: "Heather Red", hex: "#bf0d3e" },
  { name: "Heather Sage", hex: "#95a69f" },
  { name: "Heather Sand Dune", hex: "#bfa387" },
  { name: "Heather Sea Green", hex: "#00bab3" },
  { name: "Heather Slate", hex: "#586975" },
  { name: "Heather Soft Cream", hex: "#decb99" },
  { name: "Heather Sunset", hex: "#ea936d" },
  { name: "Heather Tan", hex: "#bfba9b" },
  { name: "Heather Team Purple", hex: "#7d55c7" },
  { name: "Heather True Royal", hex: "#24509a" },
  { name: "Heather Yellow", hex: "#fcea76" },
  { name: "Heather Yellow Gold", hex: "#fdd26e" },
  { name: "Ice Blue", hex: "#c4e1de" },
  { name: "Kelly", hex: "#007a53" },
  { name: "Lapis", hex: "#5c619d" },
  { name: "Lavender Blue", hex: "#6b80a2" },
  { name: "Lavender Dust", hex: "#e1d7d8" },
  { name: "Leaf", hex: "#659256" },
  { name: "Light Blue", hex: "#a6bbc8" },
  { name: "Lilac", hex: "#d1acce" },
  { name: "Maize Yellow", hex: "#f6d03a" },
  { name: "Marine", hex: "#007fa3" },
  { name: "Maroon Marble", hex: "#6a2c3e" },
  { name: "Maroon Triblend", hex: "#835362" },
  { name: "Mauve", hex: "#a36d6a" },
  { name: "Midnight", hex: "#1f2a44" },
  { name: "Midnight Navy", hex: "#313546" },
  { name: "Military Green", hex: "#60705e" },
  { name: "Mint", hex: "#a0dab3" },
  { name: "Mustard", hex: "#c6973f" },
  { name: "Natural", hex: "#dfd1a7" },
  { name: "Navy", hex: "#1f2a44" },
  { name: "Navy Marble", hex: "#1b365d" },
  { name: "Navy Speckled", hex: "#1c1f2a" },
  { name: "Navy Triblend", hex: "#3e4b65" },
  { name: "Neon Blue", hex: "#008bcc" },
  { name: "Neon Green", hex: "#44d62c" },
  { name: "Neon Orange", hex: "#ff671f" },
  { name: "Neon Pink", hex: "#ff85bd" },
  { name: "Neon Yellow", hex: "#ecf166" },
  { name: "Oatmeal", hex: "#d1ccbd" },
  { name: "Oatmeal Triblend", hex: "#beae9a" },
  { name: "Ocean Blue", hex: "#62a8c1" },
  { name: "Olive", hex: "#414823" },
  { name: "Orange", hex: "#ff6a39" },
  { name: "Orange Triblend", hex: "#ff8d6d" },
  { name: "Orchid", hex: "#a5929d" },
  { name: "Oxblood Black", hex: "#3f2537" },
  { name: "Peach", hex: "#f3be8d" },
  { name: "Pebble", hex: "#857874" },
  { name: "Pebble Brown", hex: "#857874" },
  { name: "Pine", hex: "#425e5a" },
  { name: "Pink", hex: "#f7ced7" },
  { name: "Pink Gravel", hex: "#c5aa9c" },
  { name: "Plum", hex: "#4a3041" },
  { name: "Poppy", hex: "#e10600" },
  { name: "Purple", hex: "#836995" },
  { name: "Purple Triblend", hex: "#614b79" },
  { name: "Red", hex: "#e10600" },
  { name: "Red Acid Wash", hex: "#bf0d3e" },
  { name: "Red Marble", hex: "#c0143c" },
  { name: "Red Speckled", hex: "#9d2235" },
  { name: "Royal Purple", hex: "#6a4593" },
  { name: "Rust", hex: "#9e483f" },
  { name: "Sage", hex: "#97a798" },
  { name: "Sand Dune", hex: "#c39d88" },
  { name: "Sea Green", hex: "#00bab3" },
  { name: "Seafoam Blue", hex: "#a1d3d3" },
  { name: "Silver", hex: "#c7c9c7" },
  { name: "Slate", hex: "#586975" },
  { name: "Soft Cream", hex: "#decb99" },
  { name: "Soft Pink", hex: "#eed9d4" },
  { name: "Solid Asphalt Blend", hex: "#6c6864" },
  { name: "Solid Athletic Grey", hex: "#babcc0" },
  { name: "Solid Black Triblend", hex: "#2d2926" },
  { name: "Solid Navy Blend", hex: "#1f2a44" },
  { name: "Solid Red Blend", hex: "#ba0c2f" },
  { name: "Solid True Royal Blend", hex: "#3b61a6" },
  { name: "Solid White Triblend", hex: "#f4f5f0" },
  { name: "Spring Green", hex: "#dee29f" },
  { name: "Steel Blue", hex: "#5f849c" },
  { name: "Stone", hex: "#837a58" },
  { name: "Strobe", hex: "#e7e36d" },
  { name: "Sunset", hex: "#e68e5e" },
  { name: "Synthetic Green", hex: "#2bae66" },
  { name: "Tan", hex: "#afa17c" },
  { name: "Teal", hex: "#00bfb3" },
  { name: "Teal Triblend", hex: "#737777" },
  { name: "Team Navy", hex: "#2b3e85" },
  { name: "Team Purple", hex: "#2e1a47" },
  { name: "Terracotta", hex: "#b46a55" },
  { name: "Toast", hex: "#9e6a38" },
  { name: "True Royal", hex: "#3b61a6" },
  { name: "True Royal Acid Wash", hex: "#1d4f91" },
  { name: "True Royal Marble", hex: "#1b5196" },
  { name: "True Royal Triblend", hex: "#24509a" },
  { name: "Turquoise", hex: "#00afd7" },
  { name: "Vintage Black", hex: "#212322" },
  { name: "Vintage Navy", hex: "#455d6b" },
  { name: "Vintage White", hex: "#dfddd7" },
  { name: "White", hex: "#f4f5f0" },
  { name: "White Fleck Triblend", hex: "#d9d9d6" },
  { name: "White Marble", hex: "#c8c9c7" },
  { name: "White Slub", hex: "#f1f2f1" },
  { name: "Yellow", hex: "#fcea76" },
  { name: "Yellow Gold", hex: "#f6d03a" },
];
